import { render, staticRenderFns } from "./DesktopTopCategory.vue?vue&type=template&id=66bf2e56&"
import script from "./DesktopTopCategory.vue?vue&type=script&lang=js&"
export * from "./DesktopTopCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports